import moment from "moment";
import { getHeightInInches } from "@/utils/va-order-test/index.js";
/* 
 * consts and vars used in create patient forms
 */
export var createPatientFormItems = [
  {
    prop: "firstName",
    label: "OrderPage[\"Patient's First Name\"]",
    placeholder: "OrderPage[\"First Name\"]"
  },
  {
    prop: "middleName",
    label: "OrderPage[\"Patient's Middle Name\"]",
    placeholder: "OrderPage[\"Middle Name (optional)\"]"
  },
  {
    prop: "lastName",
    label: "OrderPage[\"Patient's Last Name\"]",
    placeholder: "OrderPage[\"Last Name\"]"
  },
  {
    prop: "email",
    label: "OrderPage[\"Email Address\"]",
    placeholder: "@xxx.com",
    ref: "patientEmail"
  },
  {
    prop: "birthdate",
    label: "OrderPage[\"Patient's Date of Birth\"]",
    placeholder: "MM/DD/YYYY",
  },
  {
    prop: "gender",
    label: "OrderPage[\"Patient's Biological Sex\"]",
    placeholder: "OrderPage[\"Select Biological Sex\"]",
    options: [
      { value: "Female", label: "OrderPage[\"Female\"]" },
      { value: "Male", label: "OrderPage[\"Male\"]" }
    ]
  },
  {
    prop: "areaCode",
    ref: "patientAreaCode",
    options: [],
  },
  {
    prop: "phone",
    label: "OrderPage[\"Phone Number\"]",
    placeholder: "OrderPage[\"Phone Number\"]",
    ref: "patientPhone",
  },
  {
    prop: "streetAddress",
    label: "OrderPage[\"Street Address\"]",
    placeholder: "OrderPage[\"Street Address (optional)\"]",
    id: "street_address_id",
  },
  {
    prop: "city",
    label: "OrderPage[\"City\"]",
    placeholder: "OrderPage[\"City\"]"
  },
  {
    prop: "state",
    label: "OrderPage[\"State/Region\"]",
    placeholder: "OrderPage[\"State/Region\"]"
  },
  {
    prop: "zipcode",
    label: "OrderPage[\"Postal Code\"]",
    placeholder: "OrderPage[\"Postal Code\"]"
  },
  {
    prop: "country",
    label: "OrderPage[\"Country\"]",
    placeholder: "OrderPage[\"Country\"]",
    options: []
  },
  {
    prop: "heightInFeet",
    label: "OrderPage[\"Patient Height\"]",
    placeholder: "OrderPage[\"Feet\"]",
  },
  {
    prop: "heightInInch",
    placeholder: "OrderPage[\"Inch\"]",
  }, 
  {
    prop: "weight",
    placeholder: "OrderPage[\"Weight\"]"
  }
];
export var patient = {
  id: null,
  firstName: "",
  middleName: "",
  lastName: "",
  birthdate: "",
  gender: "",
  areaCode: "+1",
  email: "",
  phone: "",
  fullAddress: "",
  streetAddress: "",
  city: "",
  state: "",
  zipcode: "",
  country: "",
  heightInFeet: "",
  heightInInch: "",
  weight: "",
};

/* 
 * create patient form validation rules 
 */
var checkBirthDate = (rule, value, callback, t = (s) => s) => {
  if (!value) { // not check for empty value
    callback();
  }
  const regex = /((^(10|12|0?[13578])\/(3[01]|[12][0-9]|0?[1-9])\/((1[8-9]\d{2})|([2-9]\d{3}))$)|(^(11|0?[469])\/(30|[12][0-9]|0?[1-9])\/((1[8-9]\d{2})|([2-9]\d{3}))$)|(^(0?2)\/(2[0-8]|1[0-9]|0?[1-9])\/((1[8-9]\d{2})|([2-9]\d{3}))$)|(^(0?2)\/(29)\/([2468][048]00)$)|(^(0?2)\/(29)\/([3579][26]00)$)|(^(0?2)\/(29)\/([1][89][0][48])$)|(^(0?2)\/(29)\/([2-9][0-9][0][48])$)|(^(0?2)\/(29)\/([1][89][2468][048])$)|(^(0?2)\/(29)\/([2-9][0-9][2468][048])$)|(^(0?2)\/(29)\/([1][89][13579][26])$)|(^(0?2)\/(29)\/([2-9][0-9][13579][26])$))/mg;
  let birthdate = new Date(value);
  if (!birthdate || moment().isBefore(moment(birthdate)) || !value.match(regex)) {
    callback(new Error(t('OrderPage[\'Please input valid date of birth\']')));
  }
  callback();
};
export const createPatientFormRule = (t) => ({
  lastName: [
    { required: true, message: t('OrderPage[\'Please input last name\']'), trigger: 'blur' }
  ],
  firstName: [
    { required: true, message: t('OrderPage[\'Please input first name\']'), trigger: 'blur' }
  ],
  birthdate: [
    // { required: true, message: 'Please input date of birth', trigger: 'blur' },
    {
      validator: (rule, value, cb) => checkBirthDate(rule, value, cb, t),
      trigger: 'blur'
    }
  ],
  email: [
    { required: true, message: t('OrderPage[\'Please input email\']'), trigger: 'blur' }
  ],
});

export let createPatientFormRuleAddress = {
  streetAddress : [
    { required: true, message: 'Please input street address', trigger: 'blur' }
  ],
  city: [
    { required: true, message: 'Please input city', trigger: 'blur' }
  ],
  state: [
    { required: true, message: 'Please input state/province', trigger: 'blur' }
  ],
  zipcode: [
    { required: true, message: 'Please input postal code', trigger: 'blur' }
  ],
  country: [
    { required: true, message: 'Please select contry', trigger: 'change' }
  ],
}

export const createPatientFormRulePhone = (t) => ({
  phone: [
    { required: true, message: t('OrderPage[\'Please input phone number\']'), trigger: 'blur' }
  ],
});

/* 
 * get google auto complete address and fill into patient obj
 */
export function fillInGoogleAddress(patient) {
  let id = document.getElementById("street_address_id_ppn") ? 
    document.getElementById("street_address_id_ppn") :
    document.getElementById("street_address_id");
  if (!window.google) {
    return;
  }
  let autocomplete = new window.google.maps.places.Autocomplete(id, {
    // componentRestrictions: { country: ["us", "ca"] },
    fields: ["address_components"],
    types: ["address"],
  });

  window.google.maps.event.addListener(autocomplete, 'place_changed', function () {
    let place = autocomplete.getPlace().address_components;
    if (!place) {
      return
    }
    let street_number = ""
    let subpremise = ""
    let route = ""
    let state = ""
    let city = ""
    let zip = ""
    let country = ""
    place.forEach((c) => {
      if (c.types[0] === "street_number") {
        street_number = c.long_name
      } else if (c.types[0] === "route") {
        route = c.long_name
      } else if (
        (c.types[0] === "locality" || c.types[0] === 'administrative_area_level_2')
        && !city
      ) {
        city = c.long_name
      } else if (c.types[0] === "administrative_area_level_1") {
        state = c.short_name
      } else if (c.types[0] === "postal_code") {
        zip = c.long_name
      } else if (c.types[0] === "country") {
        country = c.short_name
      } else if (c.types[0] === "subpremise") {
        subpremise = c.long_name
      }
    });
    let street_number_route = street_number + " " + route 
    if (subpremise) {
      street_number_route += " " + subpremise
    }
    patient.streetAddress = street_number_route
    patient.city = city
    patient.state = state
    patient.zipcode = zip
    patient.country= country
    patient.fullAddress = [street_number_route, city, state, zip, country].filter(element => element).join(", ")
  });
}

/* 
 * format patient obj used in addNewPatientApi
 */
export function formatPatientForApi(patient) {
  let [month, day, year] = patient.birthdate.split("/");
  let feet = patient.heightInFeet ? patient.heightInFeet : "0";
  let inch = patient.heightInInch ? patient.heightInInch : "0";
  let result = {
    patient_first_name: patient.firstName,
    patient_middle_name: patient.middleName,
    patient_last_name: patient.lastName,
    patient_birthdate: patient.birthdate ? [year, month, day].join("-") : "", // re-write patient birthdate in form "yyyy-mm-dd"
    patient_gender: patient.gender,
    patient_email: patient.email,
    patient_phone: patient.phone.trim() ? patient.areaCode + "-" + patient.phone.replace(/\D/g,''): "",
    patient_street_address: patient.streetAddress,
    patient_city: patient.city,
    patient_state: patient.state,
    patient_zipcode: patient.zipcode,
    patient_country: patient.country ? patient.country : null,
    patient_height: getHeightInInches(feet, inch).toString(),
    patient_weight: patient.weight ? patient.weight : "0"
  };
  return result;
}

/* 
 * check user birthdate input and autofill separator "/"
 */
export function checkBirthdateInput(currentInput, previousInput, patient) {
  if (currentInput.length === 0)
    return;
  let lastChar = currentInput[currentInput.length-1];
  const regex = /[0-9]/;
  // delete user current input if it is not a number (need deal with '/')
  if (!lastChar.match(regex)) {
    if (lastChar === "/") {
      if (currentInput.length !== 3 && currentInput.length !== 6)
        patient.birthdate = currentInput.slice(0, -1);
    }
    else
      patient.birthdate = currentInput.slice(0, -1);
  }
  else {
    // autofill the "/" between day&month, and between month&year
  if ((previousInput.length === 1 && currentInput.length === 2) || (previousInput.length === 4 && currentInput.length === 5))
    patient.birthdate += "/";
  } 
}

/* 
 * check user phone input and autofill separator "-"
 */
export function checkPhoneInput(currentInput, previousInput, patient) {
  if (currentInput.length === 0)
    return;
  let lastChar = currentInput[currentInput.length-1];
  const regex = /[0-9]/;
  // delete user current input if it is not a number (need deal with '-')
  if (!lastChar.match(regex)) {
    if (lastChar === "-") {
      if (currentInput.length !== 4 && currentInput.length !== 8)
        patient.phone = currentInput.slice(0, -1);
    }
    else
      patient.phone = currentInput.slice(0, -1);
  }
  else {
    // autofill the "-" between number to form xxx-xxx-xxxx
    if (previousInput) {
      if ((previousInput.length === 2 && currentInput.length === 3) || (previousInput.length === 6 && currentInput.length === 7))
        patient.phone += "-";
    }
  } 
}

/* 
 * check user area code 
 */
// export function checkAreaCodeInput(currentInput, patient ) {
//   if (currentInput.length === 0)
//     return;
//   let lastChar = currentInput[currentInput.length-1];
//   const regex = /[0-9]/;
//   // delete user current input if it is not a number (need deal with '+' at the begining)
//   if (!lastChar.match(regex)) {
//     if (lastChar === "+") {
//       if (currentInput.length !== 1)
//       patient.areCode = currentInput.slice(0, -1);
//     }
//     else
//     patient.areaCode = currentInput.slice(0, -1);
//   }
//   return
// }

/* 
 * chhange the flag icon prefix of area code select
 */
export function changeFlagIcon(countryName) {
  return "https://hatscripts.github.io/circle-flags/flags/" + countryName + ".svg";
}

/* 
 * filter country options according to user input
 */
export function filterCountry(input, countryOptions) {
  if (input === "") {
    return countryOptions;
  }
  let filteredOptions = [];
  countryOptions.forEach(option => {
    // show options with matched abbreviations first
    if (option.countryNameTwoBytes.includes(input.trim().toUpperCase()))
      filteredOptions.unshift(option);
    else if (option.countryName.toLowerCase().includes(input.trim().toLowerCase()))
      filteredOptions.push(option);
  });
  return filteredOptions;
}

export function getUnsupportedCountryWarning(shippingCountryTwoByte, countryOptions) {
  let country = countryOptions.find(country => country.value === shippingCountryTwoByte);
  if (!country) {
    return "";
  }
  let countryName = country.countryName;
  if (!countryName) {
    return "";
  }
  switch(shippingCountryTwoByte) {
    case "BR": // Brazil
    case "CR": // Costa Rica
    case "EG": // Egypt
    case "MX": // Mexico
    case "PE": // Peru
    case "RU": // Russia
    case "RS": // Serbia
    case "LK": // Sri Lanka
    case "VN": // Vietnam
      return countryName + " is a Country in shipping exception list, Vibrant can't ship samples there, nor can we provide return samples service for patients.";
    case "LB": //Lebanon
    case "MY": // Malaysia
    case "PA": // Panama
    case "TR": // Turkey
      return countryName + " is a Country in shipping exception list, we can ship items here but Vibrant cannot provide return sample service for patients.";
    case "DK": // Denmark
      return countryName + " is a Country in shipping exception list, Vibrant can't ship blood kit there, nor can we drop ship return blood samples service for patients."
    case "ID": // Indonesia 
    case "NG": // Nigeria
    case "QA": // Qatar
      return countryName + " is a Country in shipping exception list, we can ship items here but a Control # will be require otherwise Vibrant cannot provide return sample service for patients. Please contact Vibrant at least one business day before sample collection to obtain one.";
    // case "PL":
    //   return countryName + " is a Country in shipping exception list, Vibrant can't ship samples to some areas.";
    case "SK": // Slovakia
      return countryName + " is a Country in shipping exception list, Vibrant can't drop ship samples there, nor can we drop ship return samples service for patients.";
    case "ZA": // Sounth Africa
      return countryName + " is a Country in shipping exception list, we can ship kits here except lancets.";
    case "IT": // Italy
    case "ES": // Spain
      return countryName + " is a Country in shipping exception list, Vibrant can't ship samples there and can only provide return sample service for patients."
      default:
      return "";
  }
}

/* auto fill patient's name info if user input name in search input field */
export function autoFillPatientName(patient, patientName) {
  if (!patientName) {
    return;
  }
  // autocomplete patient name info if user input in patient search bar already
  let name = patientName.split(" ");
  if (name.length === 1) {
    // user input first name only
    patient.firstName = name[0].toUpperCase();
  }
  else if (name.length === 2) {
    // user input first name and last name
    patient.firstName = name[0].toUpperCase();
    patient.lastName = name[1].toUpperCase();
  }
  else {
    // user input first name, middle name and last name
    // if input more(e.g "a b c d"), pick first three as first, middle and last name
    patient.firstName = name[0].toUpperCase();
    patient.middleName = name[1].toUpperCase();
    patient.lastName = name[2].toUpperCase();
  }
}